import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'global/react-mui/theme/colors';

export const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		height: 200,
		minWidth: '320px',
		alignItems: 'flex-start',
		justifyContent: 'space-around',
		borderBottom: `1px solid ${colors['silver-grey']}`,
		marginLeft: 8,
		marginRight: 8,
		padding: '12px',
		boxShadow: '0px 0px 20px #00000033'
	},
	content: {
		display: 'flex',
		flex: '1 0 auto',
		padding: '0 0 10px',
		width: '100%'
	},
	topLeftContent: {
		width: '70%'
	},
	topRighContent: {
		width: '30%'
	},
	companyName: {
		fontSize: 18,
		fontWeight: 500,
		marginBottom: 4,
		paddingRight: 10
	},
	companyDetail: {
		fontSize: 12,
		marginBottom: 8
	},
	topPartner: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 8
	},
	roundedButton: {
		borderRadius: 32,
		height: 35,
		fontSize: 14,
		color: colors['dark-grey']
	}
}));
